import {
    SET_RESET,
    SET_ERROR,
    SET_LOADING,
    SET_EVENT,
    SET_OPENING,
    SET_EXHIBITION,
    SET_SOCIAL_RESPONSIBILITIES,
    SET_BLOG,
    SET_PROJECTS,
    SET_SINGLE,
    SET_GALLERY,
    SET_EVENT_CAT


} from "./mutation_types";
import {
    GET_All_EVENT, GET_ALL_NEWS, GET_ALL_PROJECTS,
    GET_BLOG, GET_CATALOGUE, GET_DEVELOP,
    GET_EVENT, GET_EVENT_CATEGORY, GET_EXHIBITION, GET_GAllERY, GET_IMAGES, GET_OPENING, GET_PROJECTS,
    GET_RESET, GET_SINGLE, GET_SOCIAL_RESPONSIBILITIES, GET_VIDEOS,


} from "./action_types";
import {getApi,postApi} from "../../data/ApiService";
import state from "../newsManagement/state";

export default {
    async [GET_ALL_NEWS]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/89/page/1/count/100');
            console.log(response);
            commit(SET_EXHIBITION,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async getTopicComments({commit,state},topicid){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('topic/comments/'+topicid);
            console.log(response);
            state.topic_comments=response.data;
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async sendTopicComment({commit,state},payload){
        return new Promise(async(resolve,reject)=>{
            try{
                const response = await postApi('comment',payload);
                console.log(response);
                state.topic_comments=response.data;
                return resolve(response)
            }
            catch (e) {
                console.log("error",e)
                commit(SET_ERROR,e.response.message);
                return reject(e)
            }
            finally {
                // commit(SET_LOADING,false);
            }
        })
        // commit(SET_LOADING,true);
        
    },
    async [GET_EVENT]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/7/page/1/count/100');
            console.log(response);
            commit(SET_EXHIBITION,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_EVENT_CATEGORY]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('categories/12');
            console.log(response.data.categories);
            commit(SET_EVENT_CAT,response);
            for (let i=0;i<response.data.categories.length;i++){
                var item = response.data.categories[i];
                if (item.title==="گواهینامه ها و افتخارات"){
                    return item.sub_categories[0].id;
                }
            }
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_CATALOGUE]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/37/page/1/count/100');
            commit(SET_EXHIBITION,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_All_EVENT]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/3/page/1/count/100');
            console.log(response);
            commit(SET_EXHIBITION,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_OPENING]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/8/page/1/count/100');
            console.log(response);
            commit(SET_OPENING,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_EXHIBITION]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/8/page/1/count/100');
            console.log(response);
            commit(SET_EXHIBITION,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_SOCIAL_RESPONSIBILITIES]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/6/page/1/count/100');
            console.log(response);
            commit(SET_SOCIAL_RESPONSIBILITIES,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_BLOG]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/5/page/1/count/100');
            console.log(response);
            commit(SET_BLOG,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_PROJECTS]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/11/page/1/count/100');
            console.log(response);
            commit(SET_PROJECTS,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_ALL_PROJECTS]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/4/page/1/count/100');
            console.log(response);
            commit(SET_PROJECTS,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    
    async [GET_DEVELOP]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/10/page/1/count/100');
            console.log(response);
            commit(SET_PROJECTS,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    
    async get_all_news({commit,state},catId){

        commit(SET_LOADING,true);
        state.event={}
        try{
            const response = await getApi(`category/${catId}/page/1/count/100`);
            console.log(response);
            state.event=response.data;
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async get_all_blog({commit,state},catId){

        commit(SET_LOADING,true);
        state.blog={}
        try{
            const response = await getApi(`category/${catId}/page/1/count/100`);
            console.log(response);
            state.blog=response.data;
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async get_news({commit,state},catId){

        commit(SET_LOADING,true);
        state.projects={}
        try{
            const response = await getApi(`category/${catId}/page/1/count/100`);
            console.log(response);
            state.projects=response.data;
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async get_places({commit,state},catId){

        commit(SET_LOADING,true);
        state.projects={}
        try{
            const response = await getApi(`category/${catId}/page/1/count/100`);
            console.log(response);
            state.event=response.data;
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_GAllERY]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/27/page/1/count/100');
            console.log(response);
            commit(SET_GALLERY,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_IMAGES]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/28/page/1/count/100');
            console.log(response);
            commit(SET_GALLERY,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },
    async [GET_VIDEOS]({commit}){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('category/29/page/1/count/100');
            console.log(response);
            commit(SET_GALLERY,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },


    async [GET_SINGLE]({commit},payload){

        commit(SET_LOADING,true);
        try{
            const response = await getApi('topic/'+payload.id);
            console.log(response);
            commit(SET_SINGLE,response);
        }
        catch (e) {
            commit(SET_ERROR,e.response.message);
        }
        finally {
            commit(SET_LOADING,false);
        }
    },

    async [GET_RESET]({commit}) {


        commit(SET_RESET);

    },
};
